module.exports = __webpack_public_path__ + "static/img/ScottGullan.9d6a38d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ScottGullan.jpg
// module id = 34FO
// module chunks = 0